import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export default function SettingsAdmin() {
  const [form, setForm] = useState({ 
    phone: '',
    email: '',
    address: '',
    mapLink: '',
    // Social Media
    instagram: '',
    instagram_active: false,
    facebook: '',
    facebook_active: false,
    telegram: '',
    telegram_active: false,
    // Visibility
    showTreatments: true,
    showBeforeAfter: true,
    showTeam: true,
    showTestimonials: true,
    showBlogs: true,
    showGallery: true,
    showContact: true
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const { data } = await axios.get(`${API}/api/admin/settings`, { withCredentials: true });
        if (data) setForm(data);
      } catch (err) {
        toast.error('Ayarlar yüklenemedi');
      }
    };
    fetchSettings();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.put(`${API}/api/admin/settings`, form, { withCredentials: true });
      toast.success('Ayarlar başarıyla kaydedildi');
    } catch (err) {
      toast.error('Ayarlar kaydedilemedi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6 max-w-4xl">
      <h1 className="text-2xl font-bold text-slate-900">Site Ayarları</h1>
      
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Contact Info */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200 space-y-6">
          <h2 className="text-lg font-bold text-slate-900">İletişim Bilgileri</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Telefon</label>
              <input 
                type="text" 
                value={form.phone} 
                onChange={e => setForm({...form, phone: e.target.value})} 
                className="w-full px-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-primary outline-none" 
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">E-posta</label>
              <input 
                type="email" 
                value={form.email} 
                onChange={e => setForm({...form, email: e.target.value})} 
                className="w-full px-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-primary outline-none" 
              />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-slate-700 mb-1">Adres</label>
              <textarea 
                value={form.address} 
                onChange={e => setForm({...form, address: e.target.value})} 
                rows={2} 
                className="w-full px-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-primary outline-none" 
              />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-slate-700 mb-1">Google Maps Embed Linki</label>
              <input 
                type="text" 
                value={form.mapLink} 
                onChange={e => setForm({...form, mapLink: e.target.value})} 
                className="w-full px-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-primary outline-none" 
              />
            </div>
          </div>
        </div>

        {/* Social Media */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200 space-y-6">
          <h2 className="text-lg font-bold text-slate-900">Sosyal Medya</h2>
          <div className="space-y-4">
            {/* Instagram */}
            <div className="flex items-center gap-4 p-4 bg-slate-50 rounded-xl">
              <div className="flex-1">
                <label className="block text-sm font-medium text-slate-700 mb-2">Instagram URL</label>
                <input 
                  type="url" 
                  value={form.instagram} 
                  onChange={e => setForm({...form, instagram: e.target.value})} 
                  placeholder="https://instagram.com/dentakron"
                  className="w-full px-4 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-primary outline-none" 
                />
              </div>
              <div className="flex flex-col items-center gap-2 min-w-[100px]">
                <span className="text-xs font-medium text-slate-600">Göster/Gizle</span>
                <label className="relative inline-block w-14 h-7">
                  <input 
                    type="checkbox" 
                    checked={form.instagram_active} 
                    onChange={e => setForm({...form, instagram_active: e.target.checked})} 
                    className="sr-only peer" 
                  />
                  <div className="w-14 h-7 bg-slate-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-green-500"></div>
                </label>
              </div>
            </div>

            {/* Facebook */}
            <div className="flex items-center gap-4 p-4 bg-slate-50 rounded-xl">
              <div className="flex-1">
                <label className="block text-sm font-medium text-slate-700 mb-2">Facebook URL</label>
                <input 
                  type="url" 
                  value={form.facebook} 
                  onChange={e => setForm({...form, facebook: e.target.value})} 
                  placeholder="https://facebook.com/dentakron"
                  className="w-full px-4 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-primary outline-none" 
                />
              </div>
              <div className="flex flex-col items-center gap-2 min-w-[100px]">
                <span className="text-xs font-medium text-slate-600">Göster/Gizle</span>
                <label className="relative inline-block w-14 h-7">
                  <input 
                    type="checkbox" 
                    checked={form.facebook_active} 
                    onChange={e => setForm({...form, facebook_active: e.target.checked})} 
                    className="sr-only peer" 
                  />
                  <div className="w-14 h-7 bg-slate-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-green-500"></div>
                </label>
              </div>
            </div>

            {/* Telegram */}
            <div className="flex items-center gap-4 p-4 bg-slate-50 rounded-xl">
              <div className="flex-1">
                <label className="block text-sm font-medium text-slate-700 mb-2">Telegram URL</label>
                <input 
                  type="url" 
                  value={form.telegram} 
                  onChange={e => setForm({...form, telegram: e.target.value})} 
                  placeholder="https://t.me/dentakron"
                  className="w-full px-4 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-primary outline-none" 
                />
              </div>
              <div className="flex flex-col items-center gap-2 min-w-[100px]">
                <span className="text-xs font-medium text-slate-600">Göster/Gizle</span>
                <label className="relative inline-block w-14 h-7">
                  <input 
                    type="checkbox" 
                    checked={form.telegram_active} 
                    onChange={e => setForm({...form, telegram_active: e.target.checked})} 
                    className="sr-only peer" 
                  />
                  <div className="w-14 h-7 bg-slate-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-green-500"></div>
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* Page Visibility */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200 space-y-6">
          <h2 className="text-lg font-bold text-slate-900">Ana Sayfa Bölüm Görünürlükleri</h2>
          <div className="grid md:grid-cols-2 gap-4">
            <label className="flex items-center gap-3 cursor-pointer p-3 rounded-lg hover:bg-slate-50">
              <input 
                type="checkbox" 
                checked={form.showTreatments} 
                onChange={e => setForm({...form, showTreatments: e.target.checked})} 
                className="w-5 h-5 rounded text-primary focus:ring-primary" 
              />
              <span className="font-medium text-slate-700">Tedaviler</span>
            </label>
            <label className="flex items-center gap-3 cursor-pointer p-3 rounded-lg hover:bg-slate-50">
              <input 
                type="checkbox" 
                checked={form.showBeforeAfter} 
                onChange={e => setForm({...form, showBeforeAfter: e.target.checked})} 
                className="w-5 h-5 rounded text-primary focus:ring-primary" 
              />
              <span className="font-medium text-slate-700">Öncesi/Sonrası</span>
            </label>
            <label className="flex items-center gap-3 cursor-pointer p-3 rounded-lg hover:bg-slate-50">
              <input 
                type="checkbox" 
                checked={form.showTeam} 
                onChange={e => setForm({...form, showTeam: e.target.checked})} 
                className="w-5 h-5 rounded text-primary focus:ring-primary" 
              />
              <span className="font-medium text-slate-700">Hekimlerimiz</span>
            </label>
            <label className="flex items-center gap-3 cursor-pointer p-3 rounded-lg hover:bg-slate-50">
              <input 
                type="checkbox" 
                checked={form.showGallery} 
                onChange={e => setForm({...form, showGallery: e.target.checked})} 
                className="w-5 h-5 rounded text-primary focus:ring-primary" 
              />
              <span className="font-medium text-slate-700">Kayar Galeri</span>
            </label>
            <label className="flex items-center gap-3 cursor-pointer p-3 rounded-lg hover:bg-slate-50">
              <input 
                type="checkbox" 
                checked={form.showTestimonials} 
                onChange={e => setForm({...form, showTestimonials: e.target.checked})} 
                className="w-5 h-5 rounded text-primary focus:ring-primary" 
              />
              <span className="font-medium text-slate-700">Hasta Yorumları</span>
            </label>
            <label className="flex items-center gap-3 cursor-pointer p-3 rounded-lg hover:bg-slate-50">
              <input 
                type="checkbox" 
                checked={form.showBlogs} 
                onChange={e => setForm({...form, showBlogs: e.target.checked})} 
                className="w-5 h-5 rounded text-primary focus:ring-primary" 
              />
              <span className="font-medium text-slate-700">Bloglar</span>
            </label>
            <label className="flex items-center gap-3 cursor-pointer p-3 rounded-lg hover:bg-slate-50">
              <input 
                type="checkbox" 
                checked={form.showContact} 
                onChange={e => setForm({...form, showContact: e.target.checked})} 
                className="w-5 h-5 rounded text-primary focus:ring-primary" 
              />
              <span className="font-medium text-slate-700">İletişim Bölümü</span>
            </label>
          </div>
        </div>

        <div className="flex justify-end">
          <button 
            type="submit" 
            disabled={loading} 
            className="bg-primary text-white px-8 py-3 rounded-xl font-medium hover:bg-primary/90 transition-colors disabled:opacity-50"
          >
            {loading ? 'Kaydediliyor...' : 'Ayarları Kaydet'}
          </button>
        </div>
      </form>
    </div>
  );
}
